import { client } from '../http';

export default {
  async fetchSubscriptionState() {
    const response = await client.get('/api/subscription-state');
    return response.data;
  },

  async fetchFirstBillingDate() {
    const response = await client.get('/api/subscription-state/first-billing-date');
    return response.data;
  },

  async createBenefit(promotion) {
    const response = await client.post('/api/subscription-state/benefit', { promotion });
    return response.data;
  },

  async createBenefitByPromoCode(promoCode) {
    const response = await client.post('/api/subscription-state/benefit/promo-code', { promoCode });
    return response.data;
  },

  async getBenefits() {
    const response = await client.get('/api/subscription-state/benefit');
    return response.data;
  },

  async redeemBenefit(benefitId) {
    const response = await client.put(`/api/subscription-state/benefit/redeem/${benefitId}`);
    return response.data;
  },
};
